import React from 'react';
import Wrapper from '../../components/Wrapper';
import ReportForm from '../../components/Forms/ReportForm';

const CreateReport = () => {
  return (
    <Wrapper>
      <div className='d-flex flex-column justify-content-center align-items-center pt-4'>
        <h1>Create report with absorbance</h1>
        <p className='text-danger'>Use Raw Values. Conversion Will Happen Automatically</p>
        <div className=''>
          <ReportForm />
        </div>
      </div>
    </Wrapper>
  );
};

export default CreateReport;
